export default __webpack_public_path__ + "static/mais-tempo-mobile-723f856d271aed0d4b6fc555ae868d14.png";